<template>
  <div class="col-12 ">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('chapters.editChapter') }}
            </h6>
          </div>
        </div>
      </div>
    
      <LoadingSpinner v-if="isLoading" :message="$t('chapters.loadingChapter')" />

      <ChapterForm
        v-else-if="chapter"
        :initial-data="chapter"
        :loading="isUpdating"
        :is-edit-mode="true"
        :submit-text="$t('chapters.saveChanges')"
        @submit="updateChapter"
        @cancel="navigateBack"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from 'vue-toastification';
import ChapterForm from "@/components/features/chapters/ChapterForm.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import api from "@/api"; 
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const router = useRouter();
const route = useRoute();
const toast = useToast();

const isLoading = ref(false);
const isUpdating = ref(false);
const chapter = ref(null);

const fetchChapter = async () => {
  isLoading.value = true;
  try {
    const response = await api.get(`/chapters/${route.params.id}`);
    chapter.value = response.data.data;
  } catch (error) {
    toast.error(t('chapters.fetchError'));
    console.error("Error fetching chapter:", error);
    router.push({ name: 'chapters.index' });
  } finally {
    isLoading.value = false;
  }
};

const updateChapter = async (formData) => {
  isUpdating.value = true;
  try {
    await api.put(`/chapters/${route.params.id}`, formData);
    toast.success(t('chapters.updateSuccess'));
    router.push({ name: 'chapters.index' });
  } catch (error) {
    if (error.response?.status === 422) {
      toast.error(t('chapters.editValidationWarning'));
    } else {
      toast.error(error.response?.data?.message || t('chapters.updateError'));
    }
    console.error("Error updating chapter:", error);
  } finally {
    isUpdating.value = false;
  }
};

const navigateBack = () => {
  router.push({ name: 'chapters.index' });
};

onMounted(() => fetchChapter());
</script>
